import { render, staticRenderFns } from "./contact-customer.vue?vue&type=template&id=5bcedb5e&scoped=true&"
import script from "./contact-customer.vue?vue&type=script&lang=js&"
export * from "./contact-customer.vue?vue&type=script&lang=js&"
import style0 from "./contact-customer.vue?vue&type=style&index=0&id=5bcedb5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcedb5e",
  null
  
)

export default component.exports